exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "._3zmxQX5L53ho8O{margin-top:30px}._3zmxQX5L53ho8O button{margin-right:8px}@media only screen and (max-width:1020px){.LdzHprbQluLCRz{width:100%;min-width:375px}}._1ZvZ34YLUVLeEL strong{overflow-wrap:break-word}", ""]);

// exports
exports.locals = {
	"buttons": "_3zmxQX5L53ho8O",
	"illustration": "LdzHprbQluLCRz",
	"mainMessage": "_1ZvZ34YLUVLeEL"
};